/*
 * @author: YiuHai
 * @Date: 2022-03-15 10:19:23
 * @description: 退费看板
 * @LastEditors: YiuHai
 * @LastEditTime: 2022-03-15 16:13:31
 * @FilePath: /app1/src/api/retureBoard.js
 */

import request from "@/api/request";
import qs from "qs";

/**
 * 获取统计数据
 */
export const getBoardTotalDataApi = (data) => {
  return request({
    url:
      "refund/adm/refundStatistics/getRefundTotalStatistics?" +
      qs.stringify(data),
    method: "get",
  });
};

/**
 * 表格数据
 */
export const getBoardTableDataApi = (data) => {
  return request({
    url:
      "refund/adm/refundStatistics/getRefundDetailStatistics?" +
      qs.stringify(data),
    method: "get",
  });
};
